// test742
(742 && 0);
